import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { COLOR, ChipsPendientes, Cabecera, Pagina, Seccion, fechaLarga, st } from "./reportesUi";

const Tarjeta = ({ x, color, onAbrir, onVer }) => (
  <div onClick={() => (x.hecho ? onVer(x) : onAbrir(x))} style={{ ...st.tarjeta, borderColor: x.hecho ? COLOR.ok : color, background: x.hecho ? "#f0fdf4" : "#fff", cursor: "pointer" }}>
    <span style={{ fontSize: 30 }}>{x.hecho ? "✅" : "🔁"}</span>
    <span style={{ flex: 1, minWidth: 0 }}>
      <span style={{ ...st.abrev, display: "block", overflowWrap: "anywhere" }}>{x.abreviatura}</span>
      <span style={{ display: "block", fontSize: 15, color: "#475569", marginTop: 2 }}>👩‍🔧 {x.sustituta || "Sustituta"}</span>
      <span style={{ display: "flex", gap: 6, marginTop: 5, flexWrap: "wrap" }}>
        <span style={{ background: "#ccfbf1", color: "#0f766e", borderRadius: 8, padding: "1px 9px", fontSize: 12, fontWeight: 800 }}>Día {x.dia_n} de {x.dia_total}</span>
        {!x.vigente && <span style={{ background: "#f1f5f9", color: "#64748b", borderRadius: 8, padding: "1px 9px", fontSize: 12, fontWeight: 800 }}>sustitución terminada</span>}
      </span>
    </span>
    <span style={{ ...st.boton, background: x.hecho ? COLOR.ok : color }}>{x.hecho ? "👁 Ver" : "📝 Hacer"}</span>
  </div>
);

const ReportesSustituciones = () => {
  const navigate = useNavigate();
  const [d, setD] = useState(null);
  const [error, setError] = useState("");
  const cargar = useCallback(() => {
    axios.get("/api/tareas/sustituciones").then((r) => { setD(r.data); setError(""); }).catch(() => setError("❌ No se pudo cargar. Inténtalo de nuevo."));
  }, []);
  useEffect(() => { cargar(); }, [cargar]);

  const abrir = (x) => navigate("/supervisora/reporteDiario", {
    state: { piso: { id: x.id_piso, abreviatura: x.abreviatura }, modo: "sustitucion", id_sustitucion: x.id_sustitucion, fecha_dia: x.fecha, sustituta: x.sustituta },
  });
  const ver = (x) => navigate("/supervisora/verReporteDiario", {
    state: { piso: { id: x.id_piso, abreviatura: x.abreviatura }, modo: "sustitucion", id_sustitucion: x.id_sustitucion, fecha_dia: x.fecha, sustituta: x.sustituta },
  });
  const retrPorDia = useMemo(() => {
    const m = new Map();
    (d?.retrasados || []).forEach((x) => { if (!m.has(x.fecha)) m.set(x.fecha, []); m.get(x.fecha).push(x); });
    return [...m.entries()];
  }, [d]);

  return (
    <Pagina>
      <Cabecera titulo="Sustituciones" emoji="🔁" color={COLOR.sustituciones} onVolver={() => navigate("/supervisora/reportes")}>
        {d && <ChipsPendientes hoy={d.pte_hoy} retr={d.n_retrasados} grande />}
        <div style={{ fontSize: 14, color: "#64748b", marginTop: 8 }}>Un reporte al día por sustituta y piso, durante los 5 primeros días de la sustitución.</div>
      </Cabecera>
      {error && <div style={{ background: "#fee2e2", color: "#b91c1c", borderRadius: 12, padding: "10px 14px", fontWeight: 700 }}>{error}</div>}
      {!d && !error && <p style={{ textAlign: "center", color: "#64748b" }}>Cargando…</p>}
      {d && (
        <>
          <Seccion emoji="📅" titulo="Hoy" n={d.pte_hoy} color={COLOR.hoy} vacio="🎉 Nada pendiente hoy">
            {d.hoy.map((x) => <Tarjeta key={x.id_sustitucion + x.fecha} x={x} color={COLOR.sustituciones} onAbrir={abrir} onVer={ver} />)}
          </Seccion>
          <Seccion emoji="⏰" titulo="Retrasados" n={d.n_retrasados} color={COLOR.retr} vacio="🎉 No tienes retrasados">
            {retrPorDia.map(([fecha, lista]) => (
              <div key={fecha}>
                <div style={{ fontWeight: 800, color: COLOR.retr, margin: "10px 2px 8px" }}>{fechaLarga(fecha)}</div>
                {lista.map((x) => <Tarjeta key={x.id_sustitucion + x.fecha} x={x} color={COLOR.retr} onAbrir={abrir} onVer={ver} />)}
              </div>
            ))}
          </Seccion>
        </>
      )}
    </Pagina>
  );
};

export default ReportesSustituciones;
